import React from "react";
import { useNavigate } from "react-router-dom";

const Experiments = () => {
  const navigate = useNavigate();

  return (
    <section className="container pt-4 pb-5" id="experiments" style={{ maxWidth: "1200px" }}>
      <h2 className="text-dark montserrat-bold text-uppercase text-center py-1">
        Experiments
      </h2>
      <div className="row mt-4 g-4">
        {[
          {
            path: "/splat/my-table",
            title: "My Table — 3D Gaussian Splatting",
            desc: "Reconstructed from 12 photos using gsplat. Click to explore in 3D.",
          },
          {
            path: "/splat/laksa",
            title: "Laksa — 3D Gaussian Splatting",
            desc: "Reconstructed from 11 photos using gsplat. Click to explore in 3D.",
          },
        ].map(({ path, title, desc }) => (
          <div className="col-12 col-md-6" key={path}>
            <div
              onClick={() => navigate(path)}
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                overflow: "hidden",
                cursor: "pointer",
                transition: "box-shadow 0.2s",
              }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.12)"}
              onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}
            >
              <div style={{ background: "#111", height: "200px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <span style={{ color: "rgba(255,255,255,0.5)", fontSize: "48px" }}>⬡</span>
              </div>
              <div style={{ padding: "16px 20px" }}>
                <h5 className="montserrat-sbold mb-1">{title}</h5>
                <p className="montserrat-light text-muted mb-0" style={{ fontSize: "14px" }}>{desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experiments;
